import globals from 'globals';

export { globals };
